// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const List: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 17"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path d="M4.375.375H.625v3.75h3.75V.375zM7.5 1H6.25v2.5H20V1H7.5zm0 6.25H6.25v2.5H20v-2.5H7.5zm0 6.25H6.25V16H20v-2.5H7.5zM.625 6.625v3.75h3.75v-3.75H.625zm3.75 6.25H.625v3.75h3.75v-3.75z" />
        </svg>
    );
};

export default React.memo(List);
